<template>
    <v-container>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFormated"
                    :label="dataPickerTitle"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                no-title
                scrollable
                locale="pt-br"
                :type="dataPickerType"
                >
                <v-spacer></v-spacer>
                <v-btn
                    v-if="monthEnable"
                    text
                    color="primary"
                    @click="changeDatepickerType()"
                    >
                    {{ this.dataPickerChangeTypeTxBtn }}
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                    >
                    Sair
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="dispatchUpdate(date)"
                    >
                    OK
                </v-btn>
            </v-date-picker>
        </v-menu>
    </v-container>
</template>
<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { functions } from "../functions";
    import { sort } from "fast-sort";
    import moment from 'moment';
    import { dateTimeTools } from "../mixins/dateTimeTools.js";

    export default {

        name: "Datepicker1",

        components: {
        },

        mixins: [dateTimeTools],

        props: {
            eventName: String,
            dateInit: String,
            monthEnable: Boolean
        },

        data: function () {
            return {
                dataPickerType: "date",
                dataPickerChangeTypeTxBtn: "Mudar para Mês",
                dataPickerTitle: "Dia",
                date: this.dateNow(),
                menu: false,
                modal: false,
                from: null,
                to: null,
                month: null,
                year: null,
                dateStart: null,
                dateEnd: null,
            };
        },

        created: function () {

            if (this.dateInit) {
                this.date = this.dateInit;
            }

        },

        computed: {
            dateFormated() {
                return moment(this.date).format('DD-MM-YYYY');
            }
        },

        methods: {

            changeDatepickerType() {
                this.dataPickerType = this.dataPickerType == "date" ? "month" : "date";
                this.dataPickerChangeTypeTxBtn = this.dataPickerType == "date" ? "Mudar para mês" : "Mudar para dia";
                this.dataPickerTitle = this.dataPickerType == "date" ? "Dia" : "Mês";
            },

            parseDateToUrl(date) {
                return date.replaceAll("/", "-");
            },

            parseDateToUpdate(date) {
                this.dateStart = this.dateStart ? this.dateStart : this.dateTimeNow();
                this.dateEnd = this.dateEnd ? this.dateEnd : this.dateTimeNow();

                if (date) {
                    this.$refs.menu.save(date);
                    const dt = new Date(date.substr(0, 10));
                    this.date = dt.toISOString().substr(0, 10);
                    this.dateStart = this.date;
                    this.dateEnd = this.date;
                }

                if (this.dataPickerType === "month") {
                    const dt = new Date(this.dateStart);
                    const y = dt.getFullYear();
                    const m = dt.getMonth() + 1;
                    const lastDay = new Date(y, m + 1, 0);
                    this.dateEnd = lastDay.toISOString().substr(0, 10);
                }

                console.log(this.dateStart, this.dateEnd);
            },

            dispatchUpdate(date) {
                EventBus.$emit(this.eventName, {date: date});
                this.menu = false;
                this.date = date;
            }
        }
    };
</script>

<style>

</style>
